import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/index.vue'
import channel from '@/views/channel.vue'
import transactionChannel from '@/views/transactionChannel.vue'
import detail from "@/views/detail";
import tradeDetail from "@/views/tradeDetail";
import about from "@/views/about";

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        name: 'index',
        component: index,
        meta: {
            index: 1,      // 同样的标识
            keepAlive: true,
            content: '首页',
        }
    },
    {
        path: '/channel',
        name: 'channel',
        component: channel,
        meta: {
            index: 2,      // 同样的标识
            keepAlive: true,
            content: '分类'
        }
    } ,{
        path: '/detail',
        name: 'detail',
        component: detail,
        meta: {
            index: 3,      // 同样的标识
            keepAlive: true,
            content: '详情'
        }
    },{
        path: '/about',
        name: 'about',
        component: about,
        meta: {
            index: 4,      // 同样的标识
            keepAlive: true,
            content: '关于我们'
        }
    },{
        path: '/tradeInfo',
        name: 'tradeInfo',
        component: transactionChannel,
        meta: {
            index: 5,      // 同样的标识
            keepAlive: true,
            content: '交易信息'
        }
    },{
        path: '/tradeDetail/:parentId/:progress',
        name: 'tradeDetail',
        component: tradeDetail,
        meta: {
            index: 6,      // 同样的标识
            keepAlive: true,
            content: '交易详情'
        }
    },
]

const router = new VueRouter({
    mode:'history',
    routes
})


router.afterEach((to) => {
    // const title = to.meta.content || '默认标题';
    document.title = "颍上县慎祥实业发展有限公司"
});

// router.beforeEach((to, from, next) => {
//     /* 路由发生变化修改页面meta */
//     if (to.meta.content) {
//
//     }
// })

export default router
